import { type AnyInputBinding } from "./InputBinding/InputBindingUnion.type"
import { InputBindingDevice } from "./InputBindingDevice.enum"

export default function keyboardEventMatchesInputActionBinding(
  event: KeyboardEvent,
  input: AnyInputBinding,
): boolean {
  if (input.device === InputBindingDevice.Keyboard) {
    if (event.code === input.code) {
      if (input.shift && !event.shiftKey) {
        return false
      }
      if (input.ctrl && !event.ctrlKey) {
        return false
      }
      if (input.alt && !event.altKey) {
        return false
      }
      return true
    }
  }
  return false
}
